// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-actions[data-v-fbc0fd58]{display:flex;width:100%;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
